module.exports = __webpack_public_path__ + "img/H20024.42a19ff9.png";